import React from 'react'
import { useStatsJoueursDataContext } from '../../../contexts/StatsJoueursDataContext'
import styles from './styles.module.scss'

export const JoueurSearchInput = () => {
    const { joueurKeyword, setJoueurKeyword, setPage } = useStatsJoueursDataContext()

    return (
        <div>
            <form
                className={styles.search}
                onSubmit={(e) => {
                    e.preventDefault()
                    setJoueurKeyword(e.target[0].value)
                    setPage(1)
                }}
            >
                <input
                    placeholder="Rechercher un joueur..."
                    defaultValue={joueurKeyword}
                    type="text"
                />
                <i className="fi fi-rs-search" />
            </form>
        </div>
    )
}
